import {
	IGetCategoriesShort,
	IGetCategoriesByCustomerShort,
	ICreateCategory,
	ICreateCategoryV2,
	IUpdateCategory,
	IUpdateCategoryV2,
	IGetPaginatedCategories,
	IGetPaginatedCategoriesV2,
	IUpdateCategoryPositions,
	IGetCategoryRestaurantPropertiesArguments,
	IUpdateCategoryRestaurantProperties,
	IUpdateRestaurantPropertiesAsPatchForCategory,
} from 'types';
import {
	serviceGetCategoryInfo,
	serviceGetCategoryInfoV2,
	serviceGetCategoriesShort,
	serviceGetCategoriesShortV2,
	serviceGetCategoriesByCustomerShort,
	serviceCreateCategory,
	serviceCreateCategoryV2,
	serviceUpdateCategory,
	serviceUpdateCategoryV2,
	serviceGetPaginatedCategories,
	serviceGetPaginatedCategoriesV2,
	serviceDeleteCategory,
	serviceDeleteCategoryV2,
	serviceGetCategoryPositionList,
	serviceGetCategoryPositionListV2,
	serviceGetCategoryPositionChains,
	serviceGetCategoryPositionChainsV2,
	serviceUpdateCategoryPositions,
	serviceUpdateCategoryPositionsV2,
	serviceGetCategoryRestaurantProperties,
	serviceUpdateCategoryRestaurantProperties,
	serviceUpdateCategoryRestaurantPropertiesAsPatch,
	serviceUpdateRestaurantsInCategory,
	serviceGetCategoryPhotos,
} from 'services/api/categories';
import { createAppErrorMessage } from 'utils/helpers';

// Menu v1
const getCategoryInfo = async (categoryID: string) => {
	try {
		const response = await serviceGetCategoryInfo(categoryID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getCategoryInfoV2 = async (categoryID: string) => {
	try {
		const response = await serviceGetCategoryInfoV2(categoryID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getCategoriesShortInfo = async (args: IGetCategoriesShort) => {
	try {
		const response = await serviceGetCategoriesShort(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getCategoriesShortInfoV2 = async (args: IGetCategoriesShort) => {
	try {
		const response = await serviceGetCategoriesShortV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

const getCategoriesByCustomerShortInfo = async (args: IGetCategoriesByCustomerShort) => {
	try {
		const response = await serviceGetCategoriesByCustomerShort(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

// Menu v1
const createCategory = async (data: ICreateCategory) => {
	try {
		await serviceCreateCategory(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorCreatingCategory');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const createCategoryV2 = async (data: ICreateCategoryV2) => {
	try {
		const response = await serviceCreateCategoryV2(data);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorCreatingCategory');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const updateCategory = async (data: IUpdateCategory) => {
	try {
		await serviceUpdateCategory(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingCategory');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const updateCategoryV2 = async (data: IUpdateCategoryV2) => {
	try {
		await serviceUpdateCategoryV2(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingCategory');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getPaginatedCategories = async (args: IGetPaginatedCategories) => {
	try {
		const response = await serviceGetPaginatedCategories(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getPaginatedCategoriesV2 = async (args: IGetPaginatedCategoriesV2) => {
	try {
		const response = await serviceGetPaginatedCategoriesV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const deleteCategory = async (categoryID: string) => {
	try {
		await serviceDeleteCategory(categoryID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingCategory');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const deleteCategoryV2 = async (categoryID: string) => {
	try {
		await serviceDeleteCategoryV2(categoryID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingCategory');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getCategoryPositionList = async (restaurantId: string) => {
	try {
		const response = await serviceGetCategoryPositionList(restaurantId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getCategoryPositionListV2 = async (restaurantId: string) => {
	try {
		const response = await serviceGetCategoryPositionListV2(restaurantId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getCategoryPositionChains = async (restaurantId: string) => {
	try {
		const response = await serviceGetCategoryPositionChains(restaurantId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getCategoryPositionChainsV2 = async (restaurantId: string) => {
	try {
		const response = await serviceGetCategoryPositionChainsV2(restaurantId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const updateCategoryPositions = async (data: IUpdateCategoryPositions) => {
	try {
		await serviceUpdateCategoryPositions(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingCategoryPositions');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const updateCategoryPositionsV2 = async (data: IUpdateCategoryPositions) => {
	try {
		await serviceUpdateCategoryPositionsV2(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingCategoryPositions');
		throw new Error(errorMessage);
	}
};
// Menu v2

const getCategoryRestaurantProperties = async (args: IGetCategoryRestaurantPropertiesArguments) => {
	try {
		const response = await serviceGetCategoryRestaurantProperties(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const updateCategoryRestaurantProperties = async (data: IUpdateCategoryRestaurantProperties) => {
	try {
		await serviceUpdateCategoryRestaurantProperties(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingRestaurantProperties');
		throw new Error(errorMessage);
	}
};

const updateCategoryRestaurantPropertiesAsPatch = async (data: IUpdateRestaurantPropertiesAsPatchForCategory) => {
	try {
		await serviceUpdateCategoryRestaurantPropertiesAsPatch(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingRestaurantPropertiesAsPatch');
		throw new Error(errorMessage);
	}
};

const updateRestaurantsInCategory = async (data: { categoryId: string; restaurantIds: string[] }) => {
	try {
		await serviceUpdateRestaurantsInCategory(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingRestaurant');
		throw new Error(errorMessage);
	}
};

const getCategoryPhotos = async (args: { categoryIds: string[]; size: 1 | 2 | 3 }) => {
	try {
		const response = await serviceGetCategoryPhotos(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

export {
	getCategoryInfo,
	getCategoryInfoV2,
	getCategoriesShortInfo,
	getCategoriesShortInfoV2,
	getCategoriesByCustomerShortInfo,
	createCategory,
	createCategoryV2,
	updateCategory,
	updateCategoryV2,
	getPaginatedCategories,
	getPaginatedCategoriesV2,
	deleteCategory,
	deleteCategoryV2,
	getCategoryPositionList,
	getCategoryPositionListV2,
	getCategoryPositionChains,
	getCategoryPositionChainsV2,
	updateCategoryPositions,
	updateCategoryPositionsV2,
	getCategoryRestaurantProperties,
	updateCategoryRestaurantProperties,
	updateCategoryRestaurantPropertiesAsPatch,
	updateRestaurantsInCategory,
	getCategoryPhotos,
};
